import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.object.define-properties.js";
var _templateObject, _templateObject2;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import styled, { css } from 'styled-components';
import { getFont } from '@finect/tabular-utils/getFont';
import { minMediaQueries } from '@finect/tabular-utils/mediaQueries';
var dotStyles = css(["content:'';width:12px;min-width:12px;height:12px;min-height:12px;display:inline-block;background-color:", ";color:", ";border-radius:50%;margin-right:10px;"], function (_ref) {
  var theme = _ref.theme;
  return theme.linkColor;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.linkColor;
});
export var ArticleSubtitlesDot = styled.span.withConfig({
  displayName: "ArticleContentSubtitles__ArticleSubtitlesDot",
  componentId: "sc-obibl8-0"
})(["", ""], dotStyles);
export var ArticleContentSubtitles = styled.div.withConfig({
  displayName: "ArticleContentSubtitles",
  componentId: "sc-obibl8-1"
})(["margin:0 0 32px 0;padding:0;", ";", ";> div{h4{display:flex;align-items:baseline;::before{", "}margin-bottom:14px;", " b,strong{font-weight:600;}a{display:contents;font-weight:600;color:", ";}}}"], minMediaQueries.phablet(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    margin: 0 24px 32px 24px;\n  "]))), minMediaQueries.desktop(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    margin: 0 42px 32px 42px;\n  "]))), dotStyles, getFont(2, 'compact'), function (_ref3) {
  var theme = _ref3.theme;
  return theme.linkColor;
});